export default __webpack_public_path__ + "static/media/contatti.739f8995.jpg";